
















































































import {mixins} from "vue-class-component";
import {CommonMixin} from "../../../shared/services/mixin";
import {Component} from "vue-property-decorator";
import {assignValueToForm} from "@/shared/services/helper/utils";
import {AuthStore} from "@/modules/auth/store";
import ProvinceSelector from "@/modules/regions/ProvinceSelector/index.vue";
import DistrictSelector from "@/modules/regions/DistrictSelector/index.vue";
import WardSelector from "@/modules/regions/WardSelector/index.vue";
import {FormModel} from "ant-design-vue";
import {updateInformation} from "@/modules/account/service";

const form = {
    fullName: "",
    phoneNumber: "",
    sender: "",
    senderPhone: "",
    email: "",
    address: "",
    provinceId: undefined,
    districtId: undefined,
    wardId: undefined,
    billAddress: "",
    identityCard: ""
}
@Component({
    name: "Information",
    components: {WardSelector, DistrictSelector, ProvinceSelector}
})
export default class extends mixins(CommonMixin) {
    isSubmitting = false;
    form = { ...form };
    rules = {
        fullName: [{ required: true, message: 'Nhập họ tên', trigger: "change" }],
        phoneNumber: [{ required: true, message: 'Nhập số điện thoại', trigger: "change" }]
    }

    created() {
        this.form = assignValueToForm(this.form, AuthStore.user?.customer);
    }

    updateInformation() {
        (this.$refs.informationForm as FormModel).validate(async (valid) => {
            if (!valid) return;
            try {
                const { data } = await updateInformation(this.form);
                this.form = assignValueToForm(this.form, data.data);
                AuthStore.updateInfoCustomer(data.data);
                this.$message.success("Cập nhật thông tin thành công");
            } catch (e) {
                this.$message.error(e?.response?.data?.message || 'Đã xảy ra lỗi');
            }
        })
    }
}
